import React, { useRef } from 'react';
import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined';
import ButtonWithIcon from 'components/formComponents/Base/ButtonWithIcon';
import styles from './ReportDismissedSection.module.scss';
import { CYPRESS_DATA } from './constants';

const ACCEPTED_TYPES = '.xlsx';

type Props = {
  disabled?: boolean;
  onFileSelected: (file: File) => void;
  importFileBtnText: string;
};

const ExcelImportButton = ({
  disabled = false,
  onFileSelected,
  importFileBtnText,
}: Props) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      onFileSelected(file);
    }
    // Allows re-selecting the same file after a failed import.
    event.target.value = '';
  };

  return (
    <div className={styles.toolbarAction}>
      <ButtonWithIcon
        type="button"
        label={importFileBtnText}
        Icon={UploadFileOutlinedIcon}
        disabled={disabled}
        onClick={() => inputRef.current?.click()}
        dataCy={CYPRESS_DATA.importButton}
      />
      <input
        ref={inputRef}
        type="file"
        accept={ACCEPTED_TYPES}
        onChange={handleChange}
        style={{ display: 'none' }}
        data-cy={`${CYPRESS_DATA.importButton}-input`}
      />
    </div>
  );
};

export default ExcelImportButton;
